<template>
  <div>
    <div v-if="log.type === 'created' && model_log === 'Note'" class="record">
      <div class="row">
        <div class="col-3"><strong>Type</strong></div>
        <div class="col-9">{{ log.new_values.type }}</div>
      </div>
      <div class="row">
        <div class="col-3"><strong>Title</strong></div>
        <div class="col-9">{{ log.new_values.title }}</div>
      </div>
      <div class="row">
        <div class="col-3"><strong>Note</strong></div>
        <div class="col-9">
          <pre>{{ log.new_values.note }}</pre>
        </div>
      </div>
    </div>
    <div v-if="(log.type === 'deleted' || log.type === 'restored' || log.type === 'updated') && model_log === 'Note'" class="record">
      <div class="row">
        <div class="col-3"><strong>Type</strong></div>
        <div class="col-9">
          <div class="updated_value" v-if="log.new_values !== null && 'type' in log.new_values">{{ log.new_values.type }}</div>
          <div class="old_value">{{ log.old_values.type }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-3"><strong>Title</strong></div>
        <div class="col-9">
          <div class="updated_value" v-if="log.new_values !== null && 'title' in log.new_values">{{ log.new_values.title }}</div>
          <div class="old_value">{{ log.old_values.title }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-3"><strong>Note</strong></div>
        <div class="col-9">
          <div class="updated_value" v-if="log.new_values !== null && 'note' in log.new_values">
            <pre>{{ log.new_values.note }}</pre>
          </div>
          <div class="old_value">
            <pre>{{ log.old_values.note }}</pre>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3"><strong>Note Left By</strong></div>
        <div class="col-9">
          <div class="updated_value" v-if="log.new_values !== null && 'title' in log.new_values">{{ log.log_by.name }} on {{ log.new_values.updated_at | formatDateTime }}</div>
          <div class="old_value">{{ log.old_note_by.name }} on {{ log.old_values.updated_at | formatDateTime }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "note",
  props: {log: null, model_log: null},
}
</script>
